import React, { Component } from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from 'reactstrap'

class InfoModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: props.isOpen,
        }

        this.toggle = this.toggle.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.secondActionClicked = this.secondActionClicked.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.isOpen !== this.state.isOpen) {
            this.setState({ isOpen: nextProps.isOpen })
        }
    }

    closeModal() {
        this.toggle()
        if (this.props.closeModal) {
            this.props.closeModal()
        }
    }

    secondActionClicked() {
        this.toggle()
        if (this.props.secondaryAction) {
            this.props.secondaryAction()
        }
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    render() {
        const { secondaryText, secondaryAction, actionText } = this.props
        const secondaryButton = secondaryText && secondaryAction
            ? <Button color="info" onClick={this.secondActionClicked}>{secondaryText}</Button>
            : null

        return (
            <Modal isOpen={this.state.isOpen} toggle={this.toggle}>
                <ModalHeader>{this.props.headerText}</ModalHeader>
                <ModalBody>
                    {this.props.text}
                </ModalBody>
                <ModalFooter>
                    <Button color="info" onClick={this.closeModal}>{actionText}</Button>
                    {secondaryButton}
                </ModalFooter>
            </Modal>
        )
    }
}

InfoModal.defaultProps = {
    actionText: 'Schließen',
}

export default InfoModal



// WEBPACK FOOTER //
// ./src/components/Global/InfoModal.js